import { render } from "./ProfileSetup.vue?vue&type=template&id=f487faaa&ts=true"
import script from "./ProfileSetup.vue?vue&type=script&lang=ts"
export * from "./ProfileSetup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__